//=====================================================
//　メールアドレステキストボックス
//=====================================================

import { FieldValues, useFormContext, UseFormReturn } from "react-hook-form";
import { InputTag } from "../utils/ConstCommon";
import { ConstMsg } from "../utils/ConstMsg";
import { InputSelectBase } from "./InputSelectBase";
import { LblInput } from "./LblInput";
import { ValidErrMsgInline } from "./ValidErrMsgInline";

interface IFProps {
    nameYear: string,
    nameMonth: string,
    nameDate: string,
}

const FORM_TITLE = "生年月日";

export function SltBirthday(props: IFProps) {

    const cf = useFormContext();
    
    //バリデーション
    const validations = {
        validate: {
            required: function(){return requiredCheck(props, cf)},
            invalid: function(){return invalidCheck(props, cf)},
            future: function(){return futureCheck(props, cf)}
        }
    }

    //オプション
    const now = new Date();
    let i = 0;
    let optYear = [{value: "", text: ""}];
    for (i = now.getFullYear(); i >= now.getFullYear() - 120; i--){
        optYear.push({value: String(i), text: String(i)});
    }
    let optMonth = [{value: "", text: ""}];
    for (i = 1; i <= 12; i++){
        optMonth.push({value: String(i), text: String(i)});
    }
    let optDay = [{value: "", text: ""}];
    for (i = 1; i <= 31; i++){
        optDay.push({value: String(i), text: String(i)});
    }

    return (
        <div className="input-box">
            <LblInput title={FORM_TITLE} tag={InputTag.Required} />
            <ValidErrMsgInline name={props.nameYear}/>
            <div className="select-box-flex">
                <InputSelectBase name={props.nameYear} className="year" options={optYear} validations={validations} />
                <div className="select-box-unit">年</div>
                <InputSelectBase name={props.nameMonth} className="month" options={optMonth} validations={validations} />
                <div className="select-box-unit">月</div>
                <InputSelectBase name={props.nameDate} className="day" options={optDay} validations={validations} />
                <div className="select-box-unit">日</div>
            </div>
        </div>
    )

}

//-----------------------------------------------------
//　必須チェック
//-----------------------------------------------------
function requiredCheck(props: IFProps, cf: UseFormReturn<FieldValues>){

    if (cf.getValues(props.nameYear) && cf.getValues(props.nameMonth) && cf.getValues(props.nameDate)){
        return null;
    }
    return ConstMsg.EG0040004;

}

//-----------------------------------------------------
//　日付チェック
//-----------------------------------------------------
function invalidCheck(props: IFProps, cf: UseFormReturn<FieldValues>){

    let checkDate = new Date(cf.getValues(props.nameYear) + "/" + cf.getValues(props.nameMonth) + "/" + cf.getValues(props.nameDate));
    if (checkDate.getFullYear() === Number(cf.getValues(props.nameYear)) && 
        checkDate.getMonth() === Number(cf.getValues(props.nameMonth)) - 1 && 
        checkDate.getDate() === Number(cf.getValues(props.nameDate))){
        return null;
    }
    return ConstMsg.EG0040004;

}

//-----------------------------------------------------
//　未来日チェック
//-----------------------------------------------------
function futureCheck(props: IFProps, cf: UseFormReturn<FieldValues>){

    let checkDate = new Date(cf.getValues(props.nameYear) + "/" + cf.getValues(props.nameMonth) + "/" + cf.getValues(props.nameDate));
    let nowDate = new Date();
    if (nowDate >= checkDate){
        return null;
    }
    return ConstMsg.EG0040005;

}